const $ = jQuery.noConflict();

class MobileHeader {
	constructor(
		trigger = '.main-header__toggle-menu',
		pbody = 'body',
		listParent = '.main-header__nav-mobile .menu-item-has-children > button',
		parentTabButton = '.menu-item-has-children > button'
	) {
		this.trigger = trigger;
		this.pbody = pbody;
		this.listParent = listParent;
		this.parentTabButton = parentTabButton;
	}
	init() {
		$(this.trigger).on('click', this.setNavState);
		$(this.listParent).on('click', this.setListState);
		$(this.parentTabButton).on('click', this.toggleSubmenu);
	}
	setNavState(e) {
		e.preventDefault();
		const body = $('body');

		// this stays
		if ($(this).hasClass('open')) {
			MobileHeader.hideWrapper(this, body);
		} else {
			MobileHeader.showWrapper(this, body);
		}
	}

	setListState(e) {
		e.preventDefault();
		if (!$(this).hasClass('open')) {
			$(this).addClass('open');
		} else {
			$(this).removeClass('open');
		}
	}

	toggleSubmenu(e) {
		e.preventDefault();
		const parentTab = '.menu-item-has-children';

		if (e.target.closest(parentTab).classList.contains('active')) {
			e.target.closest(parentTab).classList.remove('active');
		} else if (!e.target.closest(parentTab).classList.contains('active')) {
			e.target.closest(parentTab).classList.add('active');
		} else {
			// close all others first
			$(parentTab).removeClass('active');
			e.target.closest(parentTab).classList.add('active');
		}

		// if this is the mobile menu, move menu view
		if (e.target.closest('.main-header__nav-mobile') !== null) {
			MobileHeader.showSubMenuView(e.target);
		}
	}

	static showSubMenuView(elem) {
		// console.log(elem);
		const mobileMenu = '.main-header__nav-mobile ul.menu';
		if (
			$(mobileMenu).hasClass('open') &&
			!$(mobileMenu).hasClass('secondary')
		) {
			$(mobileMenu).addClass('secondary');
			// $(mobileMenu).toggleClass('open');
		} else {
			$(mobileMenu).toggleClass('open');
			$(mobileMenu).removeClass('secondary');
		}

		// check if theyre clicking back
		if (!$(elem).hasClass('open')) {
			$(mobileMenu).toggleClass('open');
		}
	}

	static hideWrapper(el, body) {
		$(el).removeClass('open');
		body.removeClass('mobile-menu');
		$(el).next().removeClass('active');
	}

	static showWrapper(el, body) {
		$(el).addClass('open');
		body.addClass('mobile-menu');
		$(el).next().addClass('active');
	}

	resized() {
		if (
			!$(this.trigger).is(':visible') &&
			$(this.trigger).hasClass('open')
		) {
			MobileHeader.hideWrapper(this.trigger, $(this.pbody));
		}
	}

	scrolling() {
		this.$header = this.$header || $('.main-header');
		this.$header.toggleClass('active', window.pageYOffset > 0);
	}

	hideOutsideClick(e) {
		if ($(this.trigger).length > 0 && $(this.trigger).hasClass('open')) {
			const container = $('.main-header');
			if (
				!container.is(e.target) &&
				container.has(e.target).length === 0
			) {
				MobileHeader.hideWrapper(this.trigger, $(this.pbody));
			}
		}

		this.hideActiveElement(e, $('.menu-item-has-children'), 'active');
		this.hideActiveElement(e, $('.mat-select'), 'mat-select--active');

		// mega menu
		this.hideActiveElement(e, $('.menu-item.active'), 'active');
		this.hideActiveElement(e, $('.mega-menu.active'), 'active');

		if ($('body').hasClass('active-search')) {
			// Check if the clicked target is not '.trigger-search' and not a child of '.trigger-search'
			if (!$(event.target).closest('.trigger-search').length) {
				// Remove 'active' class from '.trigger-search'
				$('.trigger-search').removeClass('active');

				// Remove 'active-search' class from 'body'
				$('body').removeClass('active-search');
			}
		}

		// search bar
		// this.hideActiveElement(
		// 	e,
		// 	$('.trigger-search.active .component-lightbox__container.active'),
		// 	'active',
		// 	true
		// );

		// $('body').removeClass('active-search');

		// this.hideActiveElement( e, $( '.mat-select' ), 'mat-select--active', 'mat-select__list--active', $( '.mat-select__list' ) );
	}

	// event, element, element class
	hideActiveElement(e, elem, elemClass, removeParentClass = false) {
		// console.log('checking');
		if (elem.length > 0 && elem.hasClass(elemClass)) {
			if (!elem.is(e.target) && elem.has(e.target).length === 0) {
				// accounting for just the mega menu being active and removing the body class.
				if (
					elem !== $('.mega-menu.active') ||
					elem !== $('.menu-item.active')
				) {
					$('body').removeClass('menu-active');
				}

				if (removeParentClass && elem.parent().hasClass(elemClass)) {
					elem.parent().removeClass(elemClass);
				} else {
					elem.removeClass(elemClass);
				}
			}
		}
	}
}

export default MobileHeader;
